const borderColors = {
  default: '#B3B0AD',
  hover: '#323130',
  active: '#0078D4',
};

// jss for UI Next
// PrimitiveDropdown has been used in many place besides form in UI Next, so overriding styles in
// @bingads-webui/theme-2018 might make other components break. We export some shared style here so that
// it could be imported to and used in CC's form components along with the Dropdown together if needed.
export const DropdownStyles = {
  '& .dropdown': {
    width: '100%',

    '& .dropdown-toggle': {
      width: '100%',
      border: `1px solid ${borderColors.default}`,
      background: 'transparent !important',
      fontWeight: 400,
      alignItems: 'center',
      padding: '0 0 0 8px',
      display: 'flex',
      justifyContent: 'space-between',
      transition: 'border-color ease-in-out .15s, box-shadow ease-in-out .15s',

      '& .caret': {
        padding: '0 4px',
      },

      '&:hover': {
        borderColor: borderColors.hover,
      },

      '&:active, &:focus': {
        borderColor: borderColors.active,
      },

      '&:focus:after': {
        content: 'none',
      },
    },

    '&.open .dropdown-toggle': {
      borderColor: borderColors.active,
    },

    '& .dropdown-menu': {
      minWidth: '100%',
      maxHeight: 260,
      overflowY: 'auto',

      '& > li > a:focus:after': {
        outlineOffset: -1,
      },
    },
  },
};
